import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
    },
    track: {
        width: 56,
        height: 32,
        borderRadius: 30,
        justifyContent: 'center',
        padding: 4,
    },
    thumb: {
        width: 28,
        height: 28,
        borderRadius: 30,
        backgroundColor: COLOR.WHITE,
    },
});

export default styles;
